export default class ChainingProvider {
    public constructor(public id: number, public code: string, public label: string, public active: boolean) {}
}
